/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The CampaignsTemplates model module.
 * @module model/CampaignsTemplates
 * @version 1.0.0
 */
export class CampaignsTemplates {
  /**
   * Constructs a new <code>CampaignsTemplates</code>.
   * @alias module:model/CampaignsTemplates
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CampaignsTemplates</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CampaignsTemplates} obj Optional instance to populate.
   * @return {module:model/CampaignsTemplates} The populated <code>CampaignsTemplates</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CampaignsTemplates();
      if (data.hasOwnProperty('template'))
        obj.template = ApiClient.convertToType(data['template'], 'String');
      if (data.hasOwnProperty('split'))
        obj.split = ApiClient.convertToType(data['split'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} template
 */
CampaignsTemplates.prototype.template = undefined;

/**
 * @member {Number} split
 */
CampaignsTemplates.prototype.split = undefined;

